import { useCallback } from 'react'

import { DEFAULT_FEATURE_TOURS } from 'utilities/featureTour'
import { CLIENT_SETTING_NAMESPACES, groupedClientSettingsToObject } from 'utilities/clientSettings'
import { useClientSettings } from 'hooks/clientSettings'

const useFeatureTourSettings = (featureKey: string) => {
  const settingKey = `${CLIENT_SETTING_NAMESPACES.featureTours}.${featureKey}`
  const { value: originalSettingValue, allSettings, updateSettings } = useClientSettings(settingKey)

  const updateFeatureTourSettings = useCallback(
    <T>(value: T) => {
      const mergedValue = {
        ...originalSettingValue,
        ...value
      } as const
      updateSettings(mergedValue)
    },
    [originalSettingValue, updateSettings]
  )

  const featureTourSettings = {
    ...DEFAULT_FEATURE_TOURS,
    ...(groupedClientSettingsToObject(allSettings, CLIENT_SETTING_NAMESPACES.featureTours) || {}),
  } as const

  return {
    featureTourSettings,
    updateFeatureTourSettings,
  }
}

export default useFeatureTourSettings
